<template>
  <b-button
    v-bind="$props"
    :disabled="loading"
    v-on="$listeners"
  >
    <template v-if="loading">
      <b-spinner small />
      Loading...
    </template>
    <slot v-else /></b-button>
</template>
<script>
import { BButton, BSpinner } from 'bootstrap-vue'

export default {
  name: 'LoadingButton',
  components: {
    BButton,
    BSpinner,
  },

  props: ['loading', 'variant', 'size'],
}
</script>
